import React from "react"
import MainTemplates from "@@/templates/Main"
type Props = {}

const Main = (props: Props) => {
  return <MainTemplates />
}

export default Main
